import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { Button, InfoTooltip } from '@nps.today/component-library';
import { Text } from 'components/text/Text';
import { FunctionComponent } from 'react';
import { useTranslator } from 'translation/useTranslator';

export interface InfoDialogItem {
  label: string;
  value: any;
  furtherInfo?: string;
}

interface InfoDialogItemProps {
  item: InfoDialogItem;
}
const Item: FunctionComponent<InfoDialogItemProps> = ({ item }) => {
  return item.value ? (
    <Grid size={{ xs: 12, md: 6 }}>
      <Text
        variant="subtitle1"
        align="center"
        sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}
      >
        {item.label}
        {item.furtherInfo && <InfoTooltip description={item.furtherInfo} isText />}
      </Text>
      <Text variant="body2" align="center" sx={{ color: 'text.secondary' }}>
        {item.value}
      </Text>
    </Grid>
  ) : null;
};

interface InfoDialogProps {
  items: InfoDialogItem[];
  isOpen: boolean;
  onClose: () => void;
  dataTestId: string;
}

export const InfoDialog: FunctionComponent<InfoDialogProps> = ({
  items,
  isOpen,
  onClose,
  dataTestId
}) => {
  const translator = useTranslator();
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <DialogTitle>{translator.info()}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {items.map((item) => (
            <Item key={item.label} item={item} />
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" dataTestId={dataTestId} onClick={onClose}>
          {translator.close()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
